import { scrollPageTo } from '../utils';

export default class ScrollTo {
	constructor() {
		document.addEventListener('bless', (e) => {
			if (!e.target) {
				return;
			}

			const buttons = e.target.querySelectorAll('[data-scroll-to]');

			buttons.forEach((button) => {
				button.addEventListener('click', (e) => {
					scrollPageTo(button.dataset.scrollTo, 500);
				});
			});
		});
	}
}
